import React from 'react';
import { Form, Input, Row, Col } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined } from '@ant-design/icons';
import { SaleData } from '../../SalesManager/types';

interface CustomerInfoStepProps {
  data: Partial<SaleData>;
  updateData: (data: Partial<SaleData>) => void;
}

const CustomerInfoStep: React.FC<CustomerInfoStepProps> = ({ data, updateData }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (data.customerInfo) {
      form.setFieldsValue(data.customerInfo);
    }
  }, [data.customerInfo, form]);

  const handleValuesChange = (_changedValues: unknown, allValues: { name?: string; email?: string; phone?: string; address?: string }) => {
    updateData({
      customerInfo: {
        ...data.customerInfo!,
        ...allValues
      }
    });
  };

  return (
    <div>
      <div className="venda-step-header">
        <h4>Informação do Cliente</h4>
        <p>Preencha os dados do cliente para continuar</p>
      </div>

      <Form
        form={form}
        layout="vertical"
        onValuesChange={handleValuesChange}
        initialValues={data.customerInfo}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="name"
              label="Nome Completo"
              rules={[
                { required: true, message: 'Insira o nome' },
                { min: 2, message: 'Mínimo 2 caracteres' }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Nome completo"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="phone"
              label="Telefone"
              rules={[
                { required: true, message: 'Insira o telefone' },
                { pattern: /^[0-9\s+\-()]+$/, message: 'Formato inválido' }
              ]}
            >
              <Input
                prefix={<PhoneOutlined />}
                placeholder="912 345 678"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { type: 'email', message: 'Email inválido' }
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="email@exemplo.com"
                size="large"
                type="email"
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="address"
              label="Morada (Opcional)"
            >
              <Input
                prefix={<HomeOutlined />}
                placeholder="Morada completa"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CustomerInfoStep;
